














































	import ContentListBase from "./ContentListBase";
	import { Component } from "../../../Infrastructure/CorBase/CoreBase";

	@Component
	export default class ContentList extends ContentListBase {

		created() {
			super.initializeRights('CON_Content_Create', 'CON_Content_Delete', 'CON_Content_Read', 'CON_Content_Update');		
			super.created();
			super.setDetailName('ContentDetail');
            this.setDeleteMessage(this.$t('content.messageQuestionMain').toString(), this.$t('content.messageQuestionMain2').toString(), this.$t('content.messageQuestionMain3').toString());

		};

		changeTags(items: any, idLast: number) {
            this.changeTagsBase(items, idLast);
		}

		goBackDetailModal(item: any): void {
            this.goBackDetailModalBase(item, this.tableData);
        }

		goToTask(item: any): void {
            this.$router.push({ name: 'TaskDetail', params: { id: item.id.toString() }, query: { id: item.id.toString()} });
        }

		selectRows(items: any) {
			this.selectRowsBase(items);
		}

		loadFilters(value: any) { super.loadFilters(value); };
		createNewClick(elementId: any) { super.createNewClick(elementId); }
		detailClick(elementId: any) { super.detailClick(elementId); };

		
		showAllertToDeleteClick(itemsSelected: any) {
		//	this.showAllertToDeleteClickBase(itemsSelected);
            this.countToRemove = itemsSelected != undefined ? ((typeof itemsSelected === 'number') ? 1 : (itemsSelected as Array<any>).length) : 1;
            if (this.$store.state.askBeforeDelete) {

                super.showAlertBeforeActionClickBase(itemsSelected, super.prepareRemoveMessage(), true);
            }
            else {
                this.itemsSelected = itemsSelected;
                this.callActionClick();
            }
		}

	};
